<template>
  <div class="main">
    <div>
      <br><br><br><br><br><br><br><br>
      <h1>您目前尚未加入任何部门</h1>
      <br>

      <el-button @click="createShow" size="medium" style="width: 190px" type="primary">创建部门</el-button>
      <el-button @click="addShow" size="medium" style="width: 190px" type="info">加入部门</el-button>
    </div>


    <el-dialog :visible.sync="addFormVisible" title="加入部门">
      <el-form>
        <el-form-item :label-width="formLabelWidth" label="填入部门邀请码">
          <el-input autocomplete="off" v-model="newTeamKey"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button @click="joinTeam" type="primary">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="createFormVisible" title="创建新部门">
      <el-form>
        <el-form-item :label-width=150 px label="新部门名称">
          <el-input autocomplete="off" v-model="newTeamName"></el-input>
        </el-form-item>

        <el-form-item :label-width=150 px label="Woa群聊机器人key">
          <el-input autocomplete="off" v-model="teamWoaToken"></el-input>
        </el-form-item>

      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="createFormVisible = false">取 消</el-button>
        <el-button @click="createTeam" type="primary">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>
import {Apis} from "@/api";
import {Utils} from "@/utils/utils";

export default {
  data() {
    return {
      formLabelWidth: '120px',

      addFormVisible: false,
      createFormVisible: false,


      newTeamKey: "",
      newTeamName: "",

      teamWoaToken: "",


    }
  },
  methods: {
    resetData() {
      this.newTeamKey = ""
      this.newTeamName = ""
      this.teamWoaToken = ""
    },


    async createTeam() {
      if (this.newTeamName === "") {
        this.$message.error("请填入部门名称")
        return
      }
      if (this.newTeamName.length > 20) {
        this.$message.error("部门名称最多20个字符")
        return
      }
      if (this.teamWoaToken.length !== 32) {
        this.$message.error("woa群聊机器人的token应该是32位数字或字母")
        return
      }

      const response = await Apis.Team.createTeam(this.newTeamName,this.teamWoaToken)
      if (response.errno === 0) {
        const txt = "成功创建" + response.data.teamName
        this.$message.success(txt)
        this.resetData()
        Utils.SetTeamNum({num: 1})

        // await this.$router.push({name: "Index"})
        window.location.href="/" //会触发刷新
      }

    },

    async joinTeam() {
      if (this.addTeamKey === "") {
        this.$message.error("请填入邀请码")
        return
      }
      const response = await Apis.Team.joinTeam(this.newTeamKey)
      if (response.errno === 0) {
        const txt = "成功加入" + response.data["teamName"]
        this.$message.success(txt)
        this.resetData()
        Utils.SetTeamNum({num: 1})
        // await this.$router.push({name: "Index"}) //仅局部刷新
        window.location.href="/" //会触发刷新
      }
    },

    addShow() {
      this.addFormVisible = true
    },
    createShow() {
      this.createFormVisible = true
    }
  },
  created() {
    this.addFormVisible = false
    this.createFormVisible = false

  }
}
</script>

<style scoped>
h1 {
  text-align: center;
}

.main {
  display: flex;
  justify-content: center;
}


</style>
